const misMedicosInitialState = {
    misMedicos: {
      loading: false,
      error: null,
      data: null,
      altaEncuesta: null,      
      flgRecarga: null,      
    },
  };
  
  export default misMedicosInitialState;
  